import { Popover as AntdPopover, PopoverProps as AntdPopoverProps } from 'antd';

const Popover = (props: AntdPopoverProps) => {
  return <AntdPopover destroyOnHidden {...props} />;
};

export { Popover };
